import React, { useRef } from 'react'
import SecondHeader from '../../../components/SecondHeader/SecondHeader'
import Footer from '../../../components/Footer/Footer'
import SampleDashboardBar from '../../../components/sampleComponents/sampleDashboardTopBar/SampleDashboardBar'
import DashboardSidebarHeader from '../../../components/corporateSidebar/DashboardSidebarHeader'
import useDashboardSidebarToggle from '../../../hooks/useDashboardSidebarToggle'

const SampleDashboardLayout = ({ children }) => {
    const sidebarRef = useRef(null);
    const { sidebarOpen, closeSidebar } = useDashboardSidebarToggle(sidebarRef);

    return (
        <>
            <SecondHeader hideMobileNav />
            {sidebarOpen && <div className="dashboard-sidebar-backdrop" onClick={closeSidebar}></div>}
            <div className="dashboard-box">
                <div className="container">
                    <div className="row">
                        <div
                            ref={sidebarRef}
                            className={`col-md-12 dashboard-sidebar-col${sidebarOpen ? ' dashboard-sidebar-open' : ''}`}
                        >
                            <DashboardSidebarHeader />
                            <SampleDashboardBar />
                        </div>

                        <div className="col-md-12 sample-pages-box">
                            {children}
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    )
}

export default SampleDashboardLayout